export function articuloVacio() {
  return { titulo: '', parrafos: [''] };
}

/** Carga desde API (contenido) o estado interno (parrafos). */
export function articuloDesdeApi(item) {
  const titulo = item?.titulo || '';

  if (Array.isArray(item?.parrafos) && item.parrafos.length > 0) {
    return {
      titulo,
      parrafos: item.parrafos.map((p) => String(p ?? '')),
    };
  }

  const contenido = String(item?.contenido ?? '');
  if (!contenido.trim()) {
    return { titulo, parrafos: [''] };
  }

  const partes = contenido.split(/\n\s*\n/);
  const parrafos = partes.length > 0 ? partes : [contenido];
  return { titulo, parrafos };
}

/** Serializa para guardar en backend (un solo campo contenido). */
export function articuloParaApi(item) {
  const parrafos = (item?.parrafos || []).map((p) => String(p).trim()).filter(Boolean);
  return {
    titulo: (item?.titulo || '').trim(),
    contenido: parrafos.join('\n\n'),
  };
}

export function articuloTieneContenido(item) {
  if ((item?.titulo || '').trim()) return true;
  return (item?.parrafos || []).some((p) => String(p).trim());
}

export function obtenerParrafosArticulo(articulo) {
  if (Array.isArray(articulo?.parrafos)) {
    return articulo.parrafos.map((p) => String(p ?? ''));
  }
  const contenido = String(articulo?.contenido ?? '');
  if (!contenido.trim()) return [];
  return contenido.split(/\n\s*\n/);
}
